import { FormInput, FormInputMoney } from "@farzoom/common-ui-components";
import { Checkbox, Col, Row } from "antd";
import { disabledDate } from "../personInfoModal";
import { VerticalSpace } from "@app/UI/VerticalSpace";
import { FormInputDateTime } from "@app/common-ui-components/FormInputDateTime";

export const ProxyBlock = ({ register, control, setValue, readonly, personW }) => {
  const isDisabled = !personW?.personRole?.employee?.byProxy || readonly;

  return (
    <VerticalSpace size="small">
      <Checkbox
        {...register("personRole.employee.byProxy")}
        checked={personW?.personRole?.employee?.byProxy}
        onChange={(e) => setValue("personRole.employee.byProxy", e.target.checked)}
      >
        Действует на основании доверенности
      </Checkbox>
      <Row gutter={8}>
        <Col span={10}>
          <FormInput
            name="personRole.employee.proxy.proxyName"
            control={control}
            setValue={setValue}
            label="Наименование доверенности"
            disabled={isDisabled}
          />
        </Col>
        <Col span={7}>
          <FormInputDateTime
            name="personRole.employee.proxy.proxyDateStart"
            control={control}
            setValue={setValue}
            label="Дата выдачи"
            controls={false}
            disabledDate={disabledDate}
            disabled={isDisabled}
          />
        </Col>
        <Col span={7}>
          <FormInputDateTime
            name="personRole.employee.proxy.proxyDateEnd"
            control={control}
            setValue={setValue}
            label="Дата истечения"
            controls={false}
            disabled={isDisabled}
          />
        </Col>
      </Row>
      <Row gutter={8}>
        <Col span={10}>
          <FormInput
            name="personRole.employee.proxy.proxyNumber"
            control={control}
            setValue={setValue}
            label="Номер доверенности"
            disabled={isDisabled}
          />
        </Col>
        <Col span={7}>
          <FormInputMoney
            name="personRole.employee.proxy.proxyMaxGuaranteeAmount"
            control={control}
            setValue={setValue}
            label="Максимальная сумма БГ"
            controls={false}
            maxLength={25}
            disabled={isDisabled}
          />
        </Col>
        <Col span={7}>
          <FormInputMoney
            name="personRole.employee.proxy.proxyMaxContractAmount"
            control={control}
            setValue={setValue}
            label="Максимальная сумма договора"
            controls={false}
            maxLength={25}
            disabled={isDisabled}
          />
        </Col>
      </Row>
    </VerticalSpace>
  );
};
